// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-07958ca6],td[data-v-07958ca6],th[data-v-07958ca6]{border:1px solid #000}table[data-v-07958ca6]{width:100%;text-align:left;border-spacing:.5rem;border-collapse:collapse;table-layout:fixed;margin:1rem 0}table thead th[data-v-07958ca6]{padding:.5rem .4rem;word-break:break-word}table tbody td[data-v-07958ca6]{padding:.4rem;vertical-align:top;font-size:.9rem;word-break:break-word}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
